import {  LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"; 
import { useMainStore } from "src/settings/zustand";
import { isRole } from "src/settings/zustand/user";

export default function isFeedAuthor( linkFeedItem: LinksFeedContent ): boolean {
    return !!linkFeedItem.authorId 
        ?
        linkFeedItem.authorId === useMainStore.getState().user?.id
        :
        isRole( "administrator" )  
}